var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    {
      staticClass: "person-spec-readonly",
      class: _vm.expand === true ? "" : "bordered"
    },
    [
      _vm.expand === false
        ? _c(
            "button",
            {
              staticClass: "button small",
              class: _vm.expanded ? "expanded" : "collapsed",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.expanded = !_vm.expanded
                }
              }
            },
            [_vm._v(_vm._s(_vm.expanded ? "Collapse" : "Expand"))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-4"
            },
            [
              _c("label", [_vm._v("Person Specification Title")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "textarea",
                domProps: { innerHTML: _vm._s(_vm.personSpecification.title) }
              })
            ]
          ),
          _vm._v(" "),
          _vm.inputsClickable
            ? _c("input-emit-button", {
                attrs: { "container-class": "cell small-2" },
                on: {
                  click: function() {
                    return _vm.$emit(
                      "input-clicked",
                      "Person Specification Title",
                      _vm.personSpecification.title
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell mb-12 low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-5"
            },
            [
              _c("label", [_vm._v("Purpose of Role")]),
              _vm._v(" "),
              _c("div", {
                staticClass: "html-content",
                domProps: { innerHTML: _vm._s(_vm.personSpecification.purpose) }
              })
            ]
          ),
          _vm._v(" "),
          _vm.inputsClickable
            ? _c("input-emit-button", {
                attrs: { "container-class": "cell small-2" },
                on: {
                  click: function() {
                    return _vm.$emit(
                      "input-clicked",
                      "Purpose of Role",
                      _vm.personSpecification.purpose
                    )
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.twoColumn
        ? _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Knowledge & Education Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialKnowledgeCompetencies,
                        value: _vm.essentialKnowledgeCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge & Education Essential",
                            _vm.personSpecification.essential_knowledge_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Knowledge & Education Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialKnowledgeCompetencies,
                        value: _vm.prefentialKnowledgeCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge & Education Preferential",
                            _vm.personSpecification.preferred_knowledge_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Experience Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialExperienceCompetencies,
                        value: _vm.essentialExperienceCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Experience Essential",
                            _vm.personSpecification.essential_experience_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Experience Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialExperienceCompetencies,
                        value: _vm.prefentialExperienceCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Experience Preferential",
                            _vm.personSpecification.preferred_experience_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Skills Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialSkillCompetencies,
                        value: _vm.essentialSkillCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills Essential",
                            _vm.personSpecification.essential_skill_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Skills Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialSkillCompetencies,
                        value: _vm.prefentialSkillCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills Preferential",
                            _vm.personSpecification.preferred_skill_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Attributes Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialAttributeCompencies,
                        value: _vm.essentialAttributeCompencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes Essential",
                            _vm.personSpecification.essential_attribute_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cell mb-4 low-opacity medium-4" },
                  [
                    _c("label", [_vm._v("Attributes Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialAttributeCompencies,
                        value: _vm.prefentialAttributeCompencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes Preferential",
                            _vm.personSpecification.preferred_attribute_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c("div", { staticClass: "cell mb-4 low-opacity medium-4" }, [
                  _c("label", [_vm._v("Shift Hours")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "html-content" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.removePTag(_vm.personSpecification.shift_hours) ||
                            " "
                        ) +
                        "\n                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Shift Hours",
                            _vm.personSpecification.shift_hours
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "cell mb-4 low-opacity medium-4" }, [
                  _c("label", [_vm._v("Breaks And Lunch")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "html-content" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.removePTag(
                            _vm.personSpecification.breaks_and_lunch
                          ) || " "
                        ) +
                        "\n                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Breaks And Lunch",
                            _vm.personSpecification.breaks_and_lunch
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Shift Service Areas")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "html-content" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.personSpecification.shift_service_areas || " "
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Shift Service Areas",
                            _vm.personSpecification.shift_service_areas
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _c("div", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Knowledge & Education Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialKnowledgeCompetencies,
                        value: _vm.essentialKnowledgeCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge & Education Essential",
                            _vm.personSpecification.essential_knowledge_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Knowledge & Education Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialKnowledgeCompetencies,
                        value: _vm.prefentialKnowledgeCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Knowledge & Education Preferential",
                            _vm.personSpecification.preferred_knowledge_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Experience Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialExperienceCompetencies,
                        value: _vm.essentialExperienceCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Experience Essential",
                            _vm.personSpecification.essential_experience_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Experience Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialExperienceCompetencies,
                        value: _vm.prefentialExperienceCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Experience Preferential",
                            _vm.personSpecification.preferred_experience_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Skills Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialSkillCompetencies,
                        value: _vm.essentialSkillCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills Essential",
                            _vm.personSpecification.essential_skill_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Skills Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialSkillCompetencies,
                        value: _vm.prefentialSkillCompetencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Skills Preferential",
                            _vm.personSpecification.preferred_skill_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Attributes Essential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.essentialAttributeCompencies,
                        value: _vm.essentialAttributeCompencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes Essential",
                            _vm.personSpecification.essential_attribute_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Attributes Preferential")]),
                    _vm._v(" "),
                    _c("vue-select", {
                      staticClass: "personspec-dropdown",
                      attrs: {
                        disabled: true,
                        options: _vm.prefentialAttributeCompencies,
                        value: _vm.prefentialAttributeCompencies,
                        multiple: true
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Attributes Preferential",
                            _vm.personSpecification.preferred_attribute_competencies
                              .map(function(comp) {
                                return comp.title
                              })
                              .join(", ")
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Shift Hours")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "html-content" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.removePTag(
                              _vm.personSpecification.shift_hours
                            ) || " "
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Shift Hours",
                            _vm.personSpecification.shift_hours
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Breaks And Lunch")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "html-content" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.removePTag(
                              _vm.personSpecification.breaks_and_lunch
                            ) || " "
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Breaks And Lunch",
                            _vm.personSpecification.breaks_and_lunch
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.expanded,
                    expression: "expanded"
                  }
                ],
                staticClass: "grid-x grid-padding-x",
                class: this.readonlyGridPosition
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "cell mb-4 low-opacity",
                    class: _vm.compact === true ? "auto" : "medium-6 large-5"
                  },
                  [
                    _c("label", [_vm._v("Shift Service Areas")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "html-content" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.removePTag(
                              _vm.personSpecification.shift_service_areas
                            ) || " "
                          ) +
                          "\n                "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.inputsClickable
                  ? _c("input-emit-button", {
                      attrs: { "container-class": "cell small-2" },
                      on: {
                        click: function() {
                          return _vm.$emit(
                            "input-clicked",
                            "Shift Service Areas",
                            _vm.personSpecification.shift_service_areas
                          )
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell",
              class: _vm.compact === true ? "small-12" : "medium-8 large-6"
            },
            [
              _c("label", { staticClass: "mb-0 low-opacity" }, [
                _vm._v("Employment Phases")
              ]),
              _vm._v(" "),
              !_vm.compact
                ? _c(
                    "div",
                    { staticClass: "grid-x grid-padding-x low-opacity" },
                    [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.personSpecification.employment_phase_specs, function(
                employmentPhase
              ) {
                return _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4 ml-1",
                    class: _vm.readonlyGridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell low-opacity",
                        class: _vm.compact === true ? "auto" : "small-4"
                      },
                      [
                        _vm.compact === true
                          ? _c("label", { staticClass: "fw-normal mb-1" }, [
                              _vm._v("Employment Phase:")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "textarea" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.removePTag(employmentPhase.title)) +
                              "\n                    "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cell low-opacity",
                        class: _vm.compact === true ? "auto" : "small-4"
                      },
                      [
                        _vm.compact === true
                          ? _c("label", { staticClass: "fw-normal mb-1" }, [
                              _vm._v("Duration:")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "textarea" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.removePTag(employmentPhase.duration)) +
                              "\n                    "
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cell low-opacity",
                        class: _vm.compact === true ? "auto" : "small-3"
                      },
                      [
                        _vm.compact === true
                          ? _c("label", { staticClass: "fw-normal mb-1" }, [
                              _vm._v("Rate:")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "textarea" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.removePTag(employmentPhase.rate)) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.inputsClickable
                          ? _c("input-emit-button", {
                              attrs: { "container-class": "cell" },
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Rate",
                                    employmentPhase.rate
                                  )
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("input-emit-button", {
                          attrs: { "container-class": "cell" },
                          on: {
                            click: function() {
                              return _vm.$emit(
                                "input-clicked",
                                "Employment Phase | Duration | Rate",
                                employmentPhase.title +
                                  " | " +
                                  employmentPhase.duration +
                                  " | " +
                                  employmentPhase.rate
                              )
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x"
        },
        [
          _c(
            "div",
            {
              staticClass: "cell",
              class: _vm.compact === true ? "small-12" : "medium-6 large-5"
            },
            [
              _c("label", { staticClass: "mb-0 low-opacity" }, [
                _vm._v("Background Verification")
              ]),
              _vm._v(" "),
              !_vm.compact
                ? _c(
                    "div",
                    { staticClass: "grid-x grid-padding-x low-opacity" },
                    [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.personSpecification.background_verification_specs
                ? _c(
                    "div",
                    _vm._l(
                      _vm.personSpecification.background_verification_specs,
                      function(verificationSpec) {
                        return _c(
                          "div",
                          {
                            staticClass: "grid-x grid-padding-x mb-4 ml-1",
                            class: _vm.readonlyGridPosition
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Verification Type:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.removePTag(verificationSpec.title)
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Method:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.removePTag(verificationSpec.method)
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Notes:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        verificationSpec.method === "ifacts"
                                          ? _vm.removePTag(
                                              verificationSpec.ifacts_check
                                                .title
                                            )
                                          : _vm.removePTag(
                                              verificationSpec.notes
                                            )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.inputsClickable
                              ? _c("input-emit-button", {
                                  attrs: { "container-class": "cell small-2" },
                                  on: {
                                    click: function() {
                                      return _vm.$emit(
                                        "input-clicked",
                                        "Verification Type | Method | Notes",
                                        verificationSpec.title +
                                          " | " +
                                          verificationSpec.method +
                                          " | " +
                                          (verificationSpec.method === "ifacts"
                                            ? verificationSpec.ifacts_check
                                                .title
                                            : verificationSpec.notes || "")
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }
                    ),
                    0
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x mb-4",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell",
              class: _vm.compact === true ? "small-12" : "medium-6 large-5"
            },
            [
              _c("label", { staticClass: "mb-0 low-opacity" }, [
                _vm._v("Skills Assessments")
              ]),
              _vm._v(" "),
              !_vm.compact
                ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c(
                      "div",
                      {
                        staticClass: "cell",
                        class: _vm.compact === true ? "small-12" : "small-4"
                      },
                      [_c("label", [_vm._v("Verification Type:")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cell",
                        class: _vm.compact === true ? "small-12" : "small-4"
                      },
                      [_c("label", [_vm._v("Method:")])]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "cell",
                        class: _vm.compact === true ? "small-12" : "small-4"
                      },
                      [_c("label", [_vm._v("Notes:")])]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.personSpecification.skill_assessment_specs
                ? _c(
                    "div",
                    _vm._l(
                      _vm.personSpecification.skill_assessment_specs,
                      function(skillAssessmentSpec) {
                        return _c(
                          "div",
                          {
                            staticClass: "grid-x grid-padding-x mb-4 ml-1",
                            class: _vm.readonlyGridPosition
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Assessment Type:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.removePTag(
                                          skillAssessmentSpec.title
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Method:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.removePTag(
                                          skillAssessmentSpec.method
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "cell pl-0 low-opacity",
                                class: _vm.compact === true ? "auto" : "small-4"
                              },
                              [
                                _vm.compact
                                  ? _c(
                                      "label",
                                      { staticClass: "fw-normal mb-1" },
                                      [_vm._v("Notes:")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "textarea" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.removePTag(
                                          skillAssessmentSpec.instructions
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _vm.inputsClickable
                              ? _c("input-emit-button", {
                                  attrs: { "container-class": "cell small-2" },
                                  on: {
                                    click: function() {
                                      return _vm.$emit(
                                        "input-clicked",
                                        "Assessment Type | Method | Notes",
                                        skillAssessmentSpec.title +
                                          " | " +
                                          skillAssessmentSpec.method +
                                          " | " +
                                          (skillAssessmentSpec.method ===
                                          "classmarker"
                                            ? skillAssessmentSpec
                                                .classmarker_assessment.title
                                            : skillAssessmentSpec.benchmark ||
                                              "")
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }
                    ),
                    0
                  )
                : _vm._e()
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x mb-4",
          class: this.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell small-12",
              class: _vm.compact === true ? "auto" : "medium-6"
            },
            _vm._l(_vm.personSpecification.killer_questions, function(
              killerQuestionSpec,
              i
            ) {
              return _c(
                "fieldset",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.expanded,
                      expression: "expanded"
                    }
                  ],
                  key: i,
                  staticClass: "killer-question-fieldset",
                  class: _vm.questionsClass
                },
                [
                  _c("label", { staticClass: "low-opacity" }, [
                    _vm._v("Killer Questions")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "grid-x grid-padding-x",
                      class: _vm.readonlyGridPosition
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cell mb-4 low-opacity",
                          class:
                            _vm.compact === true ? "auto" : "medium-6 large-5"
                        },
                        [
                          _c("label", [
                            _vm._v("Question " + _vm._s(i + 1) + ":")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "textarea" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.removePTag(killerQuestionSpec.title)
                                ) +
                                "\n                        "
                            )
                          ])
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(6, true),
                  _vm._v(" "),
                  killerQuestionSpec.killer_question_answers
                    ? _c(
                        "div",
                        _vm._l(
                          killerQuestionSpec.killer_question_answers,
                          function(answer, j) {
                            return _c(
                              "div",
                              {
                                key: j,
                                staticClass:
                                  "grid-x grid-padding-x mb-4 low-opacity"
                              },
                              [
                                _c("div", { staticClass: "cell small-6" }, [
                                  _c("div", { staticClass: "textarea" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.removePTag(answer.title)) +
                                        "\n                            "
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "cell small-6" }, [
                                  _c("div", { staticClass: "textarea" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          answer.is_correct ? "Pass" : "Fail"
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                ])
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e()
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expanded,
              expression: "expanded"
            }
          ],
          staticClass: "grid-x grid-padding-x",
          class: _vm.readonlyGridPosition
        },
        [
          _c(
            "div",
            {
              staticClass: "cell mb-4 low-opacity",
              class: _vm.compact === true ? "auto" : "medium-6 large-5"
            },
            [
              _c("label", [_vm._v("Client Original Brief")]),
              _vm._v(" "),
              _vm.personSpecification.client_original_brief
                ? _c(
                    "div",
                    [
                      _c("small", [
                        _vm._v("(Existing: "),
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href:
                                _vm.personSpecification.client_original_brief
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.personSpecification.client_original_brief
                              )
                            )
                          ]
                        ),
                        _vm._v(")")
                      ]),
                      _vm._v(" "),
                      _c("FileInputControl", {
                        attrs: { name: "client_original_brief", disabled: true }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Employment Phases:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Duration:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Rate:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Verification Type:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Method:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell small-4" }, [
      _c("label", [_vm._v("Notes:")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid-x grid-padding-x low-opacity" }, [
      _c("div", { staticClass: "cell small-6" }, [
        _c("label", [_vm._v("Answer:")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-6" }, [
        _c("label", [_vm._v("Result:")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1221eb82", { render: render, staticRenderFns: staticRenderFns })
  }
}